export default class HexSearch {
    constructor(worksheet) {
        this.worksheet = worksheet;
        this.title = localStorage.getItem("title");
        this.terms = localStorage.getItem("terms").split("\n");
        this.definitions = localStorage.getItem("definitions").split("\n");
        this.bank = localStorage.getItem("bank");
        this.together = localStorage.getItem("together");
        if (localStorage.getItem("size") && localStorage.getItem("size") != undefined)
            this.size = parseInt(localStorage.getItem("size"));
        else
            this.size = 1;
        this.grid = [];
        this.alphabet = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", 'y', "z"];
        // Change the terms to lower case and set the size.
        for (var i = 0; i < this.terms.length; i++) {
            this.terms[i] = this.terms[i].toLowerCase();
            for (var j = 0; j < this.terms[i].length; j++)
                if (this.alphabet.indexOf(this.terms[i].charAt(j)) == -1)
                    this.alphabet.push(this.terms[i].charAt(j));
            if (this.terms.length > this.size)
                this.size = this.terms.length;
        }
        for (var j = 0; j < Math.floor(this.size * 1.5); j++) {
            this.grid[j] = [];
            for (var i = 0; i < this.size; i++) {
                this.grid[j][i] = {};
            }
        }
        while (!this.placeTerms(this.terms, this.grid) && this.size < 100) {
            this.size++;
            this.grid = [];
            for (var j = 0; j < Math.floor(this.size * 1.5); j++) {
                this.grid[j] = [];
                for (var i = 0; i < this.size; i++) {
                    this.grid[j][i] = {};
                }
            }
        }
        ;
        this.placeBogusWords(this.terms, this.grid);
        this.placeBogusLetters(this.alphabet, this.grid);
        this.createWordSearch(this.worksheet);
    }
    getRandomLocation(term, grid) {
        /* Only returns valid locations for the term */
        var locations = [];
        var valid = false;
        var directions = [[1, 0], [0, 1], [-1, 0], [0, -1], [-1, -1], [1, 1]];
        var dx, dy;
        var intersections;
        for (var i = 0; i < this.size; i++) {
            for (var j = 0; j < this.size; j++) {
                for (var k = 0; k < directions.length; k++) {
                    dx = directions[k][0];
                    dy = directions[k][1];
                    intersections = 0;
                    if (2 * i >= j && 2 * i + 2 * dx * term.length >= j + dy * term.length)
                        if (i + dx * term.length <= this.size + Math.floor(j + dy * term.length) / 2)
                            if (i + dx * term.length >= 0 && j + dy * term.length >= 0 && j + dy * term.length < this.size) {
                                if (j % 2 == 0 || i < this.size - 1) {
                                    valid = true;
                                    for (var l = 0; l < term.length; l++) {
                                        if (grid[i + l * dx]) {
                                            if (grid[i + l * dx][j + l * dy].value)
                                                if (grid[i + l * dx][j + l * dy].value != term.charAt(l)) {
                                                    valid = false;
                                                    break;
                                                }
                                                else
                                                    intersections++;
                                        }
                                        else {
                                            valid = false;
                                            break;
                                        }
                                    }
                                    if (valid && intersections != term.length)
                                        locations.push([i, j, dx, dy, intersections]);
                                }
                            }
                }
            }
        }
        if (this.together == "true") {
            locations.sort(function (a, b) {
                return b[4] - a[4];
            });
            for (var i = 0; i < locations.length; i++)
                if (locations[i][4] < locations[0][4]) {
                    locations.splice(i, 1);
                    i--;
                }
        }
        return locations[Math.floor(Math.random() * locations.length)];
    };
    placeTerms(terms, grid) {
        var location;
        for (var i = 0; i < terms.length; i++) {
            location = this.getRandomLocation(terms[i], grid);
            if (location) {
                for (var j = 0; j < terms[i].length; j++) {
                    grid[location[0] + j * location[2]][location[1] + j * location[3]].term = true;
                    grid[location[0] + j * location[2]][location[1] + j * location[3]].value = terms[i].charAt(j);
                }
            }
            else {
                return false;
            }
        }
        return true;
    };
    placeBogusLetters(alphabet, grid) {
        for (var i = 0; i < Math.floor(this.size * 1.5); i++)
            for (var j = 0; j < this.size; j++)
                if (2 * i >= j)
                    if (i <= this.size + Math.floor(j / 2))
                        if (!grid[i][j].value)
                            grid[i][j].value = alphabet[Math.floor(Math.random() * alphabet.length)];
    };
    placeBogusWords(terms, grid) {
        var location, bogus, bogusAlphabet, iterations = 10;
        for (var k = 0; k < iterations; k++) {
            for (var i = 0; i < terms.length; i++) {
                location = this.getRandomLocation(terms[i], grid);
                if (location) {
                    bogus = Math.floor(Math.random() * terms[i].length);
                    bogusAlphabet = this.alphabet.slice();
                    bogusAlphabet.splice(bogusAlphabet.indexOf(terms[i].charAt(bogus)), 1);
                    for (var j = 0; j < terms[i].length; j++) {
                        if (grid[location[0] + j * location[2]][location[1] + j * location[3]].value || j != bogus)
                            grid[location[0] + j * location[2]][location[1] + j * location[3]].value = terms[i].charAt(j);
                        else
                            grid[location[0] + j * location[2]][location[1] + j * location[3]].value = bogusAlphabet[Math.floor(Math.random() * bogusAlphabet.length)];
                    }
                }
                else
                    return false;
            }
        }
        return true;
    };
    createWordSearch(worksheet) {
        // Create title
        var title = document.createElement("h4");
        title.className = 'text-center';
        title.innerHTML = this.title;
        worksheet.appendChild(title);
        // Create word search
        for (var j = 0; j < this.size; j++) {
            var row = document.createElement("div");
            row.className = "row";
            row.style.height = Math.floor(720 / (this.size)) + "px";
            if (j % 2) {
                row.style.marginLeft = 0;
                row.style.marginRight = 0;
            }
            for (var i = 0; i < Math.floor(this.size * 1.5); i++) {
                if (this.grid[i][j] && 2 * i >= j && i < this.size + Math.floor(j / 2)) {
                    var element = document.createElement("div");
                    element.className = "col";
                    if (this.grid[i][j].term)
                        element.className += " shaded";
                    element.style.lineHeight = Math.floor(720 / this.size) + "px";
                    element.style.fontSize = Math.floor(720 / this.size) + "px";
                    if (this.grid[i][j].value && this.grid[i][j].value != " ")
                        element.innerHTML = this.grid[i][j].value;
                    row.appendChild(element);
                }
            }
            this.worksheet.appendChild(row);
        }
        if (this.bank == "true") {
            let hr = document.createElement('hr');
            worksheet.appendChild(hr);
            // Create bank title
            var titleB = document.createElement("h4");
            titleB.className = 'text-center';
            titleB.innerHTML = "Word Bank";
            this.worksheet.appendChild(titleB);
            // Create bank
            var bank = document.createElement("div");
            for (var i = 0; i < this.terms.length; i++) {
                bank.innerHTML += this.terms[i];
                if (i < this.terms.length - 1)
                    bank.innerHTML += ", ";
            }
            this.worksheet.appendChild(bank);
        }
    };
}
